import notification from '@/api/notification-history'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  notification_types: [],
  selected_notification_type: null,
  from_date: moment()
    .add(-3, 'Month')
    .format('DD-MM-YYYY'),
  to_date: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_NOTIFICATION_TYPES(state, data) {
    state.notification_types = data
  },
  SET_SELECTED_NOTIFICATION_TYPE(state, id) {
    state.selected_notification_type = id
  },
  SET_FROM_DATE(state, from_date) {
    state.from_date = from_date
  },
  SET_TO_DATE(state, to_date) {
    state.to_date = to_date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        not_type_id: context.state.selected_notification_type,
        from_date: context.state.from_date,
        to_date: context.state.to_date
      },
      attrubutes
    )
    return notification.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async dataBeforeCreate(context) {
    if (!context.state.notification_types.length > 0) {
      let response = await notification.notificationTypes()
      context.commit('SET_NOTIFICATION_TYPES', response)
    }
  }
}
